import React from "react";
import Select from "react-select";
import { Modal,ModalHeader,ModalBody,ModalFooter,Button,Row,Col,Label } from "reactstrap";

const LeadFilters = ({ isOpen, toggle, filters, setFilters, stages=[], projects=[], forms=[],users=[], pages=[], hideAssignedToFilter = false, }) => {
  console.log("filters",filters);
  const handle=(key,val)=>{
    setFilters((p)=>({
      ...p,
      [key]:val,
      page:1,
    }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        Lead Filters
      </ModalHeader>

      <ModalBody>
        <Row className="g-3">
          <Col md={6}>
            <Label>Source</Label>
            <Select
              value={[
                { label: "All", value: "all" },
                { label: "Facebook", value: "facebook" },
                { label: "Google", value: "google" },
                { label: "Generic / Import", value: "generic" },
              ].find((s) => s.value === filters.source)}
              onChange={(e) => handle("source", e?.value || "all")}
              options={[
                { label: "All", value: "all" },
                { label: "Facebook", value: "facebook" },
                { label: "Google", value: "google" },
                { label: "Generic / Import", value: "generic" },
              ]}
            />
          </Col>
          <Col md={6}>
            <Label>Stage</Label>

            <Select
              value={
                stages.find(
                  (s)=>s._id===filters.stage
                )
                  ? {
                      label: stages.find(
                        (s)=>s._id===filters.stage
                      )?.name,
                      value: filters.stage,
                    }
                  : null
              }
              onChange={(e)=>
                handle("stage",e?.value || "")
              }
              options={stages.map((s)=>({
                label:s.name,
                value:s._id,
              }))}
              isClearable
            />
          </Col>

          <Col md={6}>
            <Label>Project</Label>

            <Select
              value={
                projects.find(
                  (p)=>p._id===filters.projectId
                )
                  ? {
                      label: projects.find(
                        (p)=>p._id===filters.projectId
                      )?.projectName,
                      value: filters.projectId,
                    }
                  : null
              }
              onChange={(e)=>
                handle("projectId",e?.value || "")
              }
              options={projects.map((p)=>({
                label:p.projectName,
                value:p._id,
              }))}
              isClearable
            />
          </Col>

          <Col md={6}>
            <Label>Form</Label>

            <Select
                value={
                  forms.find(
                    (f)=>f.formId===filters.formId
                  )
                    ? {
                        label: forms.find(
                          (f)=>f.formId===filters.formId
                        )?.formName,
                        value: filters.formId,
                      }
                    : null
                }
                onChange={(e)=>
                  handle("formId",e?.value || "")
                }
                options={forms.map((f)=>({
                  label:f.formName,
                  value:f.formId,
                }))}
                isClearable
              />
          </Col>

          <Col md={6}>
            <Label>Page</Label>

            <Select
              value={
                pages.find(
                  (p)=>p.refId===filters.pageId
                )
                  ? {
                      label: pages.find(
                        (p)=>p.refId===filters.pageId
                      )?.name,
                      value: filters.pageId,
                    }
                  : null
              }
              onChange={(e)=>
                handle("pageId",e?.value || "")
              }
              options={pages.map((p)=>({
                label:p.name,
                value:p.refId,
              }))}
              isClearable
            />
          </Col>
          {!hideAssignedToFilter && (
            <Col md={6}>
              <Label>Assigned User</Label>

              <Select
                value={
                  users.find(
                    (u)=>u._id===filters.assignedTo
                  )
                    ? {
                        label: `${
                          users.find(
                            (u)=>u._id===filters.assignedTo
                          )?.firstName || ""
                        } ${
                          users.find(
                            (u)=>u._id===filters.assignedTo
                          )?.lastName || ""
                        }`,
                        value: filters.assignedTo,
                      }
                    : null
                }
                onChange={(e)=>
                  handle("assignedTo",e?.value || "")
                }
                options={users.map((u)=>({
                  label:`${u.firstName || ""} ${u.lastName || ""}`,
                  value:u._id,
                }))}
                isClearable
              />
            </Col>
          )}
          <Col md={6}>
            <Label>Sort By</Label>

            <Select
              value={{
                label:filters.sortBy,
                value:filters.sortBy,
              }}
              onChange={(e)=>
                handle("sortBy",e?.value)
              }
              options={[
                { label:"Name", value:"name" },
                { label:"Email", value:"email" },
                { label:"Phone", value:"phone" },
                { label:"Created Date", value:"createdTime" },
              ]}
            />
          </Col>

          <Col md={6}>
            <Label>Sort Order</Label>

            <Select
              value={{
                label:filters.sortOrder,
                value:filters.sortOrder,
              }}
              onChange={(e)=>
                handle("sortOrder",e?.value)
              }
              options={[
                { label:"Descending", value:"desc" },
                { label:"Ascending", value:"asc" },
              ]}
            />
          </Col>

        </Row>
      </ModalBody>

      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LeadFilters;